
class VideoAutoplay extends HTMLElement {
    constructor() {
      super();
  
      this.videoElement = null;
      this.intersectionObserver = null;
    }
  
    connectedCallback() {
      this.videoElement = this.querySelector('video');
      if (this.videoElement) {
        this.intersectionObserver = new IntersectionObserver(this.handleIntersection.bind(this), { threshold: 0 });
        this.intersectionObserver.observe(this.videoElement);
      }
  
    }
  
    disconnectedCallback() {
      if (this.intersectionObserver) {
        this.intersectionObserver.unobserve(this.videoElement);
        this.intersectionObserver = null;
      }
    }
  
    handleIntersection(entries) {
      const isVisible = entries[0].isIntersecting;
      if (isVisible) {
        this.playVideo();
        console.log('play');
      } else {
        this.pauseVideo();
        console.log('pause');
      }
    }
  
    playVideo() {
      if (this.videoElement) {
        this.videoElement.play();
      }
    }
  
    pauseVideo() {
      if (this.videoElement) {
        this.videoElement.pause();
      }
    }
  }
  
  if (!window.customElements.get('video-autoplay')) {
    customElements.define('video-autoplay', VideoAutoplay);
  }
  